"use strict";
// <copyright file="LoaderDetalhesSumarioAtendimento.tsx" company="Top365">
// Copyright (c) Top365. All rights reserved.
// </copyright>
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var _ = require('lodash');
require("./loader.scss");
/** Component for displaying loading component. */
var LoaderDetalhesSumarioAtendimento = function () {
    return (React.createElement("div", { className: "taskModuleDetalhes" },
        React.createElement(react_northstar_1.Skeleton, { animation: "wave" },
            React.createElement(react_northstar_1.Flex, { column: true },
                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", style: {
                        minHeight: 70,
                    }, column: true },
                    React.createElement(react_northstar_1.Skeleton.Line, { height: "40px", width: "100px" }),
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "150px" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", style: {
                        minHeight: 70,
                    }, column: true },
                    React.createElement(react_northstar_1.Skeleton.Line, { height: "40px", width: "100px" }),
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "200px" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", style: {
                        minHeight: 70,
                    }, column: true },
                    React.createElement(react_northstar_1.Skeleton.Line, { height: "40px", width: "100px" }),
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "250px" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", style: {
                        minHeight: 70,
                    }, column: true },
                    React.createElement(react_northstar_1.Skeleton.Line, { height: "40px", width: "100px" }),
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "150px" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", style: {
                        minHeight: 70,
                    }, column: true },
                    React.createElement(react_northstar_1.Skeleton.Line, { height: "40px", width: "100px" }),
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "200px" }))))));
};
exports.default = LoaderDetalhesSumarioAtendimento;
//# sourceMappingURL=loaderDetalhesSumarioAtendimento.js.map